import { HttpClient } from '@angular/common/http';
import { Terms } from '../../../models/terms';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { Clock } from '../../../utils/clock';
import { Injectable } from '@angular/core';
import { TermsEnum } from '../../../enum/terms.enum';
import { Shipment } from '../../../models/shipment';

@Injectable({
    providedIn: 'root'
})
export class TermsService {

    constructor(private httpClient: HttpClient) {}

    get(id: string): Observable<Terms> {
        return this.httpClient.get<Terms>(`${environment.apiUrl}/terms/${id}`);
    }

    agree(id: string): Observable<Terms> {
        return this.httpClient.put<Terms>(`${environment.apiUrl}/terms/${id}`, { id, agreementTimestamp: Clock.now() });
    }

    termsRequiredToQuote(shipment: Shipment): TermsEnum[] {
        return [ TermsEnum.GENERAL ];
    }

    termsRequiredToSubmit(shipment: Shipment): TermsEnum[] {
        const terms = [ TermsEnum.GENERAL ];
        if (shipment.shipper.country !== shipment.destination.country) {
            terms.push(TermsEnum.INTERNATIONAL);
        }
        return terms;
    }

}
